import { ImageAnchor } from "./util";

type rect = [number, number, number, number];

export class FlyerImageAnchor extends ImageAnchor {
  public positionInParent(screenRect: rect | null) {
    const a = this.anchor;
    if (!screenRect || !a) return;

    a.style.left = screenRect[0] + "px";
    a.style.top = screenRect[1] + "px";
    a.style.width = screenRect[2] + "px";
    a.style.height = screenRect[3] + "px";
  }
  public getScreenRect(parentRect: rect, screenScaleX: number, screenScaleY: number): rect | null {
    const srcRectNumbers = this.srcRectNumbers;
    if (!srcRectNumbers) return null;

    const [x, y, w, h] = srcRectNumbers;
    const [srcLeft, srcTop] = parentRect;

    return [(x - srcLeft) * screenScaleX, (y - srcTop) * screenScaleY, w * screenScaleX, h * screenScaleY];
  }
  get srcRectNumbers(): [number, number, number, number] | null {
    const str = this.getAttribute("src-rect");
    if (!str) return null;

    const pieces = str.split(" ").filter((x) => x.length > 0);
    if (pieces.length !== 4) return null;

    return [Number(pieces[0]), Number(pieces[1]), Number(pieces[2]), Number(pieces[3])];
  }
}
customElements.define("sfml-flyer-image-a", FlyerImageAnchor);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/image/flyter-image-anchor.ts